import script from "./CustomFieldsMixin.vue?vue&type=script&lang=ts"
export * from "./CustomFieldsMixin.vue?vue&type=script&lang=ts"

export default script